import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";


// Import all images from folder
function importAll(r) {
  return r.keys().map(r);
}
const allImages = importAll(
  require.context("../public/backgroundimg", false, /\.(png|jpe?g|svg)$/)
);

const TOTAL_VISIBLE = 20;       // number of tiles
const ROTATE_INTERVAL = 2000;   // time between cell updates (ms)

export default function LivingCollageBackground({ children }) {
  const [images, setImages] = useState([]);
  const nextIndex = useRef(0);

  useEffect(() => {
    // Fill the grid with the first images
    const initial = Array.from({ length: TOTAL_VISIBLE }, () => ({
      src: allImages[nextIndex.current++ % allImages.length],
      id: Math.random().toString(36).substr(2, 9),
    }));
    setImages(initial);

    const interval = setInterval(() => {
      setImages((prev) => {
        const randomIdx = Math.floor(Math.random() * TOTAL_VISIBLE);
        const updated = [...prev];
        updated[randomIdx] = {
          src: allImages[nextIndex.current++ % allImages.length],
          id: Math.random().toString(36).substr(2, 9),
        };
        return updated;
      });
    }, ROTATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Background grid */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          zIndex: -1,
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gridTemplateRows: "repeat(4, 1fr)",
          pointerEvents: "none",  // so clicks pass through to foreground
          backgroundColor: "black",
        }}
      >

        {images.map(({ src, id }) => (
            <AnimatePresence initial={false} key={id}>
                <motion.div
                key={id}
                style={{ aspectRatio: "1 / 1", width: "100%" }}
                >
                <motion.img
                    src={src}
                    alt=""
                    initial={{ opacity: .3}}
                    animate={{ opacity: .4 }}
                    exit={{ opacity: .3 }}
                    transition={{ duration: 2000000, ease: "easeInOut" }}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                    }}
                />
                </motion.div>
            </AnimatePresence>
            ))}
      </div>

      {/* Foreground content */}
      <div
        style={{
          position: "relative",
          zIndex: 0,
          width: "100%",
          height: "100%",
        }}
      >
      </div>
    </>
  );
}
